



































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  fontFaceList,
  predefineColors,
  formAddList,
  shortFormAddList,
  countdownTimeOption,
  borderRadiusOptions,
  borderStyleOptions,
  typesettingOptions,
  typesettingOptions1,
  fontSizeOptions,
  backgroundOptions,
  containerBorderRadiusOptions,
} from '../../../constant/options';
import YcColorPicker from '@/components/color-picker/index.js';
import compontentForm from '../../../components/form.vue';
import { PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import discountDialog from '../../../components/discountDialog.vue';
import { getCompanyInfo } from '@/model/CompanyInfo';
import EventBus from '@/utils/eventBus';
import { getFontFaceList } from '@/utils/getFontFaceList';
import TextAlignPicker from '@/components/text-align/index.vue';
import WheelOptionsCollapse from './WheelOptionsCollapse.vue';
import { getVueAppUploadApi } from '@/services/util';
import { isEnableWheelCouponSetting } from '@/utils/experiment';

@Component({
  components: {
    'yc-color-picker': YcColorPicker,
    'compontent-form': compontentForm,
    discountDialog: discountDialog,
    'text-align-picker': TextAlignPicker,
    WheelOptionsCollapse
  }
})
export default class wheelOfFortuneTextStart extends Vue {
  @Prop(Object)
  formData!: TFormSaveDetailRequest<PopSettingsVO>;

  @Prop(Number)
  triggerEventType!: any;

  @Prop(Array)
  countryList!: any;

  formDataStart: TFormSaveDetailRequest<PopSettingsVO> = this.formData;
  formList = this.formData.settings?.start || [];

  // 选择框选项
  get formAddList() {
    if (this.formData.settings.combinationType == 2) {
      return formAddList.filter(item => {
        if (item.label != 'Email') {
          return item;
        }
      });
    } else {
      return formAddList;
    }
  }
  shortFormAddList = shortFormAddList;
  countdownTimeOption = countdownTimeOption;
  predefineColors = predefineColors;
  fontFaceList = getFontFaceList(fontFaceList);
  borderRadiusOptions = borderRadiusOptions;
  borderStyleOptions = borderStyleOptions;
  typesettingOptions = typesettingOptions;
  fontSizeOptions = fontSizeOptions;
  backgroundOptions = backgroundOptions;
  typesettingOptions1 = typesettingOptions1;
  containerBorderRadiusOptions = containerBorderRadiusOptions;

  countdownTime: string = 'minute';
  countDown: number = 5;
  collapseArr = ['1', '2'];
  emailOpen: boolean = this.formData.settings.rules.emailOpen === true && this.formData.settings.rules.emailPosition === 'start';
  couponCodeShow: boolean = this.formData.settings.rules.couponCodeShow === true && this.formData.settings.rules.couponCodePosition === 'start';
  compontentFormIsShow = false;
  formType = {};

  uploadUrl = getVueAppUploadApi() + '/upload/formImage';
  uploadDialogVisible = false;
  uploadDialogUrl = '';

  bgUploadFileList: { name: string; url: string }[] = [];
  bgUploadShow = false;
  logoUploadFileList: { name: string; url: string }[] = [];
  logoUploadShow = false;
  leftAdImageFileList: { name: string; url: string }[] = [];
  leftAdImageShow = false;
  rightAdImageFileList: { name: string; url: string }[] = [];
  rightAdImageShow = false;
  textAreaUploadShow = false;
  textAreaFileList: { name: string; url: string }[] = [];

  zpbgUploadFileList: { name: string; url: string }[] = [];
  zpbgUploadShow = false;
  pointUploadFileList: { name: string; url: string }[] = [];
  pointUploadShow = false;

  showDiscountDialog = false;

  // wheelOptionsCollapse同步
  onWheelOptionsChange(list: any[]) {
    console.log('onWheelOptionsChange', list);
    this.formDataStart.settings.discountList = list;
    this.changeStart();
  }

  get enableFormOptimize() {
    return true;
  }

  get enableWheelCouponSetting() {
    return isEnableWheelCouponSetting() && this.formDataStart.settings.discountList && this.formDataStart.popWindowWheel === 1;
  }

  get enableInputFontFamily() {
    return [30, 2317].includes(getCompanyInfo()?.id as number);
  }

  get enableSubscribeDifferentPage() {
    return this.formDataStart.successPageType === 1
  }

  get enableMobileRatio() {
    return [30, 2631].includes(getCompanyInfo().id as number);
  }

  get company33aPopDisable() {
    const disablePop =
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 33 && this.formData?.id == '55abadf02473424aa42004745e4b74f6') ||
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 30 && this.formData?.id == '8eaf5e5c7d244b65bc9843e98f33d08d');
    return disablePop;
  }

  get companyis535() {
    const status = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id === 535;
    return status;
  }

  get shopType() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `shopify`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `shopline`;
      }
    }
    if (companyInfo.integrationType) {
      return companyInfo.integrationType?.toLowerCase();
    }
    return ``;
  }

  get formStyle() {
    const rules = this.formDataStart.settings.rules;
    const styleMap = this.formDataStart.settings.styles.styleMap;
    return `
      .cartx-option-columns{
        min-width: ${Math.floor(100 / (rules.optionColumns || 1)) - 3}%!important;
        color: ${rules.optionColor}!important;
      }
      .cartx-option-columns .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns .el-checkbox__input.is-checked .el-radio__inner {
        border-color: ${rules.optionColor}!important;
      }
      .cartx-option-columns .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns .el-radio__input.is-checked .el-radio__inner {
        border-color: ${rules.optionBackground}!important;
        background: ${rules.optionBackground}!important;
      }
      .cartx-question {
        color: ${rules.optionColor}!important;
      }
      .cartx-form .el-input__inner {
        border-width: ${rules.inputType === 'bottom' ? '0 0 1px 0' : '1px'}!important;
        border-style: ${rules.inputBorderStyle}!important;
        border-color: ${rules.inputBorderColor}!important;
        border-radius: ${rules.inputBorderRadius}!important;
        background: ${rules.inputBackgroundShow !== 'none' ? rules.inputBackground : 'none'}!important;
        color: ${rules.inputColor}!important;
        ${styleMap['cartx-b-input']['font-family'] ? `font-family: ${styleMap['cartx-b-input']['font-family']} !important;` : ''}
      }
      .cartx-form input::-webkit-input-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form input:-moz-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form input::-moz-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form input:-ms-input-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
    `;
  }

  get token() {
    return localStorage.getItem('token') || 'default';
  }

  get showLeftRightAdImage() {
    return ['35', '49'].includes(`${Number(this.$route.query.templateid) || this.formData.templateId}`);
  }

  get isPopZhuanpan() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return (
      this.formData.popWindowWheel === 1 ||
      tid === '36' ||
      tid === '37' ||
      tid === '38' ||
      tid === '39' ||
      tid === '40' ||
      tid === '42' ||
      tid === '43' ||
      `${this.formData.id}` === '1e1609bc024d4517989039886ac7ed34' ||
      `${this.formData.id}` === 'abdac5d809824d8280ffff395a854a15'
    );
  }

  get leftAdImageDisabled() {
    const disabled = this.formDataStart?.settings?.typesetting?.leftAdImage || this.leftAdImageShow;
    return disabled;
  }

  get rightAdImageDisabled() {
    const disabled = this.formDataStart?.settings?.typesetting?.rightAdImage || this.rightAdImageShow;
    return disabled;
  }

  get showDiscountSetting() {
    return sessionStorage.getItem('isShopify') === '1';
    // const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    // const companyId = company?.id;
    // return ((companyId === 30 || companyId === 563 || companyId === 565 || companyId === 577 || companyId === 578 || companyId === 579 || companyId === 580 || companyId === 581 || companyId === 582 || companyId === 680 || companyId === 681)) && this.triggerEventType !== 3;
  }

  gaClickFun(key:string,name:string){
    window?.gtagClick(key,name)
  }

  changeDiscountType() {
    // console.log('changeDiscountType', this.formDataStart.settings.discountType);
    if (this.formDataStart.settings.discountType === 'guding') {
      this.formDataStart.settings.discount = null;
    } else {
      this.showDiscountDialog = true;
    }
    // this.formDataStart.settings.discountType = 'guding';

    // 发送事件通知其他组件
    EventBus.$emit('discount-type-changed', this.formDataStart.settings.discountType);
    this.changeStart();
  }
  showDiscountDialogHandle() {
    this.showDiscountDialog = true;
  }
  saveDiscount(discount: any) {
    this.formDataStart.settings.rules.couponCode = '';
    this.formDataStart.settings.discount = discount;
    this.formDataStart.settings.discountType = 'dongtai';
    // 发送事件通知
    EventBus.$emit('discount-type-changed', 'dongtai');
    this.showDiscountDialog = false;
    this.changeStart();
  }
  closeDiscount() {
    if (this.formDataStart.settings.discountType === 'guding') {
      this.formDataStart.settings.discountType = 'guding';
      this.changeStart();
    }
    this.showDiscountDialog = false;
  }

  changcompontentFormIsShow(e: boolean) {
    this.compontentFormIsShow = e;
  }

  addFormAddList(item: any, index: number) {
    if (this.collapseArr.indexOf('1') < 0) {
      this.collapseArr.push('1');
    }
    if (item.type !== '自定义') {
      let a = this.formList.filter((i: any) => {
        return i.type === item.type;
      });

      if (a.length > 0) {
        this.formType = a[0];
        this.compontentFormIsShow = true;
        return;
      }
      let b =
        this.formDataStart.settings.end?.filter((i: any) => {
          return i.type === item.type;
        }) || [];
      if (b.length > 0) {
        this.$message.error('您添加了多个' + item.label + '表单，请检查设置是否有误');
        return;
      }
    }

    if (this.formList.length < 8) {
      this.formType = item;
      this.compontentFormIsShow = true;
    } else {
      this.$message.error('最多只能添加8个表单');
    }
    window?.gtagClick('form_edit_selectField_'+item?.label.replace(/\s/g, ''),'弹窗_编辑订阅工具_选择采集项_'+item?.label.replace(/\s/g, ''))
  }

  //倒计时计算
  changecountDownShow() {
    if (this.countdownTime === 'minute') {
      this.formDataStart.settings.rules.countDown = this.countDown * 60;
    } else if (this.countdownTime === 'second') {
      this.formDataStart.settings.rules.countDown = this.countDown;
    }
    this.changeStart();
  }

  changeFormList(e: any) {
    this.formDataStart.settings.start = e;
    if (this.stepDisplayDisabled) {
      Vue.set(this.formDataStart.settings.rules, 'stepDisplay', false);
    }
    this.changeStart();
  }

  changeImgPosition() {
    if (this.formDataStart?.settings?.typesetting?.imgPosition != 'background') {
      this.formDataStart.settings.typesetting.bgbox = false;
    }
    this.changeStart();
  }

  changeStart() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton','弹窗_编辑订阅工具_设置关闭按钮')
  }
  changeStartGA() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton','弹窗_编辑订阅工具_设置关闭按钮')
  }

  changeStartWithGtag(key: string, name: string) {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick(key, name);
  }

  changeCouponCodePosition() {
    if (this.couponCodeShow) {
      if (this.formData.settings.rules.couponCodePosition === 'end') {
        this.$message.warning('结束页面已经展示coupon');
        this.couponCodeShow = false;
      } else {
        this.formDataStart.settings.rules.couponCodePosition = 'start';
        this.formDataStart.settings.rules.couponCodeShow = this.couponCodeShow;
      }
    } else {
      if (this.formData.settings.rules.couponCodePosition === 'end') {
        this.formDataStart.settings.rules.couponCodePosition = 'end';
      } else {
        this.formDataStart.settings.rules.couponCodePosition = '';
      }
    }
    this.changeStart();
  }

  changeCouponCodeType() {
    this.changeStart();
  }

  blurPointDeg() {
    if (!this.formDataStart.settings.rules.pointFinallyDeg) {
      this.formDataStart.settings.rules.pointFinallyDeg = 0;

      const input = document.querySelector('.wheel-setting-deg-input input');
      if (input) {
        input.value = '0';
      }
    }
  }

  changePointDeg() {
    if (!this.formDataStart.settings.rules.pointFinallyDeg) {
      this.formDataStart.settings.rules.pointFinallyDeg = 0;

      const input = document.querySelector('.wheel-setting-deg-input input');
      if (input) {
        input.value = '0';
      }
    }
    this.changeStart();
  }

  get stepDisplayDisabled() {
    return (
      this.formData.settings.start?.reduce(
        (info, form, index, arr) => {
          // 仅包含'Email'和'Mobile Number'时可以勾选；
          if (form.type === 'Email' || form.type === 'Mobile Number') {
            info.ok.add(form.type);
          } else {
            info.err.add(form.type);
          }
          let newdisabled = true;
          if (arr.length == 2) {
            newdisabled = !(arr[0]?.type == 'Email' && arr[1]?.type == 'Mobile Number');
          } else {
            newdisabled = info.ok.size !== 2 || info.err.size !== 0;
          }
          info.disabled = newdisabled;
          return info;
        },
        { ok: new Set(), err: new Set(), disabled: true }
      ).disabled ||
      !this.formData.settings.end ||
      this.formData.settings.end.length !== 0
    );
  }

  @Watch('formData.settings.typesetting.imgUrl', { immediate: true })
  typesettingImgUrlChange(val: string) {
    if (val) {
      this.bgUploadShow = true;
      this.bgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }
  @Watch('formData.settings.typesetting.bgImgUrl', { immediate: true })
  typesettingBGImgUrlChange(val: string) {
    if (val) {
      this.zpbgUploadShow = true;
      this.zpbgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }
  @Watch('formData.settings.typesetting.pointImgUrl', { immediate: true })
  typesettingPointImgUrlChange(val: string) {
    if (val) {
      this.pointUploadShow = true;
      this.pointUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.logo.imgUrl', { immediate: true })
  logoImgUrlChange(val: string) {
    if (val) {
      this.logoUploadShow = true;
      this.logoUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.typesetting.leftAdImage', { immediate: true })
  leftAdImageUrlChange(val: string) {
    if (val) {
      this.leftAdImageShow = true;
      this.leftAdImageFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.typesetting.rightAdImage', { immediate: true })
  rightAdImageUrlChange(val: string) {
    if (val) {
      this.rightAdImageShow = true;
      this.rightAdImageFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.texts.textAreaImgUrl', { immediate: true })
  textAreaImgUrlChange(val: string) {
    if (val) {
      this.textAreaUploadShow = true;
      this.textAreaFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.rules.emailOpen')
  emailOpenChange(val: boolean) {
    if (val === true && this.formData.settings.rules.emailPosition === 'start') {
      this.emailOpen = true;
    } else {
      this.emailOpen = false;
      if (this.formData.settings.rules.emailPosition === 'end') {
        this.formDataStart.settings.rules.emailPosition = 'end';
      } else {
        this.formDataStart.settings.rules.emailPosition = '';
      }
    }
  }

  @Watch('formData.settings.rules.emailPosition')
  emailPositionChange(val: string) {
    this.emailOpen = this.formData.settings.rules.emailOpen === true && val === 'start';
  }

  @Watch('formData.settings.rules.couponCodeShow')
  couponCodeShowChange(val: boolean) {
    this.couponCodeShow = val === true && this.formData.settings.rules.couponCodePosition === 'start';
  }

  @Watch('formData.settings.rules.couponCodePosition')
  couponCodePositionChange(val: string) {
    this.couponCodeShow = this.formData.settings.rules.couponCodeShow === true && val === 'start';
  }

  mounted() {
    if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.formDataStart.settings.discountType = 'guding';
    } else {
      this.formDataStart.settings.discountType = 'dongtai';
    }
    
    // 设置移动端广告位比例默认值
    if (!this.formDataStart.settings.rules.mobileRatio && this.enableMobileRatio) {
      this.formDataStart.settings.rules.mobileRatio = 'recommendRatio';
    }
  }

  @Watch('formData')
  changeFormData() {
    this.formDataStart = this.formData;
    // if (!this.formDataStart.settings.discountType) {
    if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.formDataStart.settings.discountType = 'guding';
    } else {
      this.formDataStart.settings.discountType = 'dongtai';
    }
    
    // 设置移动端广告位比例默认值
    if (!this.formDataStart.settings.rules.mobileRatio && this.enableMobileRatio) {
      this.formDataStart.settings.rules.mobileRatio = 'recommendRatio';
    }
    // }
  }
  @Watch('formData.settings.rules.countDown')
  changeCountDown(val: number) {
    if (val > 60) {
      this.countDown = val / 60;
      this.countdownTime = 'minute';
    } else if (val === 60) {
      this.countdownTime = 'second';
      this.$nextTick(() => {
        this.countDown = 60 / 1;
      });
    } else {
      this.countdownTime = 'second';
      this.countDown = val;
    }
  }

  @Watch('formData.settings.start')
  changeStartFormList(val: any) {
    this.formList = val;
  }

  /**
   * 图片上传失败钩子函数
   */
  bgHandleError(e: any): void {
    this.bgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  bgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.bgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrl = res.data[0].url);
      this.bgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.bgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  bgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE =
      file.type === "image/jpeg" ||
      file.type === "image/gif" ||
      file.type === "image/webp" ||
      file.type === "image/png" ||
      file.type === "image/jpg";
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.bgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  bgUploadUrlDelete() {
    this.bgUploadShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrl = '');
  }

  /**
   * 图片上传失败钩子函数
   */
  zpbgHandleError(e: any): void {
    this.zpbgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  zpbgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.zpbgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.bgImgUrl = res.data[0].url);
      this.zpbgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.zpbgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  zpbgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.zpbgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  zpbgUploadUrlDelete() {
    this.zpbgUploadShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.bgImgUrl = '');
  }

  /**
   * 图片上传失败钩子函数
   */
  pointHandleError(e: any): void {
    this.pointUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  pointHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.pointUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.pointImgUrl = res.data[0].url);
      this.pointUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.pointUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  pointBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.pointUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  pointUploadUrlDelete() {
    this.pointUploadShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.pointImgUrl = '');
  }

  /**
   * 图片上传失败钩子函数
   */
  logoHandleError(e: any): void {
    this.logoUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  logoHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.logoUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.logo && (this.formDataStart.settings.logo.imgUrl = res.data[0].url);
      this.logoUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.logoUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  logoBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.logoUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  logoUploadUrlDelete() {
    this.logoUploadShow = false;
    this.formDataStart?.settings?.logo && (this.formDataStart.settings.logo.imgUrl = '');
  }

  // 左图上传

  /**
   * 图片上传失败钩子函数
   */
  leftAdImageHandleError(e: any): void {
    this.leftAdImageShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  leftAdImageHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.leftAdImageShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.leftAdImage = res.data[0].url);
      this.leftAdImageFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.leftAdImageShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  leftAdImageBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.leftAdImageShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  leftAdImageUrlDelete() {
    this.leftAdImageShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.leftAdImage = '');
    this.changeStart();
  }

  // 右图上传

  /**
   * 图片上传失败钩子函数
   */
  rightAdImageHandleError(e: any): void {
    this.rightAdImageShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  rightAdImageHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.rightAdImageShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.rightAdImage = res.data[0].url);
      this.rightAdImageFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.rightAdImageShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  rightAdImageBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.rightAdImageShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  rightAdImageUrlDelete() {
    this.rightAdImageShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.rightAdImage = '');
    this.changeStart();
  }

  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }

  /**
   * 图片上传失败钩子函数
   */
  textAreaHandleError(e: any): void {
    this.textAreaUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  textAreaHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.textAreaUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.texts && (this.formDataStart.settings.texts.textAreaImgUrl = res.data[0].url);
      this.textAreaFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.textAreaUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  textAreaBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.textAreaUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  textAreaUploadUrlDelete() {
    this.textAreaUploadShow = false;
    this.formDataStart?.settings?.texts && (this.formDataStart.settings.texts.textAreaImgUrl = '');
    this.changeStart();
  }
  /**
   * 点击上传图片
   */
  textAreaClick() {
    window.gtagClick('form_edit_setTextImage', '弹窗_编辑订阅工具_设置文本区域图片');
  }
}
